class PromoBar {
  constructor(el) {
    this.promoContainer = el;
    this.promoMsgBefore = this.promoContainer.querySelector(".promo-msg.before");
    this.promoMsgAfter = this.promoContainer.querySelector(".promo-msg.after");
    this.promoMeter = this.promoContainer.querySelector(".promo-meter .meter-indicator");

    this.PROMO_THRESHOLD = parseInt(this.promoContainer.dataset.threshold);
    this.PROMO_THRESHOLD_TYPE = this.promoContainer.dataset.thresholdType;
    this.PROMO_ELIGIBLE_TYPE = this.promoContainer.dataset.eligibleType;
    this.PROMO_THRESHOLD_PRODUCT_ID = this.promoContainer.dataset.thresholdProductId;

    this.init();
  }

  async init() {
    const cartData = await this.getCart();
    this.reRender(cartData);
  }

  async getCart() {
    try {
      const response = await fetch(window.Shopify.routes.root + "cart.js");
      const data = await response.json();
      return data;
    } catch (err) {
      console.error(err);
    }
  }

  getGiftCardPrices(cartData) {
    let giftCardPrices = 0;

    const giftCards = cartData.items.filter((item) => item.handle === "gift-card");

    if (giftCards.length > 0) {
      giftCardPrices = giftCards
        .map((giftCard) => giftCard.final_line_price)
        .reduce((curr, acc) => curr + acc);
    }

    return giftCardPrices;
  }

  updatePromoMsgBefore(message) {
    const thresholdMessageEl = this.promoMsgBefore.querySelector(".promo-threshold");
    if (!thresholdMessageEl) return;

    this.promoMsgBefore.querySelector(".promo-threshold").textContent = message;
  }

  reRender(cartData) {
    let aboveThreshold = false;
    let difference = 0;
    let beforeMessage = "";

    const productIds = cartData.items.map((item) => item.product_id);

    const hasEligibleItems = productIds.some((productId) =>
      this.PROMO_THRESHOLD_PRODUCT_ID.includes(productId)
    );
    const sidecartShipping = document.querySelector(".sidecart__shipping");

    if (sidecartShipping) {
      if (hasEligibleItems) {
        sidecartShipping.classList.add("display-none");
      } else {
        sidecartShipping.classList.remove("display-none");
      }
    }

    if (this.PROMO_THRESHOLD_TYPE === "product" && this.PROMO_THRESHOLD_PRODUCT_ID) {
      // Specific Product in Cart
      // difference == number of matching items in cart
      const matchingLineItems = cartData.items.filter((item) =>
        this.PROMO_THRESHOLD_PRODUCT_ID.includes(item.product_id.toString())
      );

      matchingLineItems.forEach((item) => {
        difference = difference + item.quantity;
      });

      aboveThreshold = difference >= this.PROMO_THRESHOLD;
      beforeMessage = this.PROMO_THRESHOLD - difference;
    } else if (this.PROMO_THRESHOLD_TYPE === "money" && this.PROMO_THRESHOLD_PRODUCT_ID) {
      const productIds = cartData.items.map((item) => item.product_id);

      if (productIds.some((productId) => this.PROMO_THRESHOLD_PRODUCT_ID.includes(productId))) {
        // const giftCardPrices = this.getGiftCardPrices(cartData);
        // https://pthree.atlassian.net/browse/BAR-217
        const giftCardPrices = 0;

        if (this.PROMO_ELIGIBLE_TYPE === "collection") {
          let eligibleTotal = 0;
          cartData.items.forEach((item) => {
            eligibleTotal += item.original_line_price;
          });

          difference = eligibleTotal - giftCardPrices;
          aboveThreshold = eligibleTotal - giftCardPrices >= this.PROMO_THRESHOLD;
        } else {
          difference = cartData.original_total_price - giftCardPrices;
          aboveThreshold = cartData.original_total_price - giftCardPrices >= this.PROMO_THRESHOLD;
        }

        beforeMessage = "$" + ((this.PROMO_THRESHOLD - difference) / 100).toFixed(2);
        this.promoContainer.style.display = "block";
      } else {
        this.promoContainer.style.display = "none";
      }
    } else {
      // Minimum Cart Value
      // const giftCardPrices = this.getGiftCardPrices(cartData);
      // https://pthree.atlassian.net/browse/BAR-217
      const giftCardPrices = 0;
      difference = cartData.original_total_price - giftCardPrices;
      aboveThreshold = cartData.original_total_price - giftCardPrices >= this.PROMO_THRESHOLD;
      beforeMessage = "$" + ((this.PROMO_THRESHOLD - difference) / 100).toFixed(2);
    }

    this.updatePromoMsgBefore(beforeMessage);

    if (aboveThreshold) {
      this.promoMsgBefore.style.display = "none";
      this.promoMsgAfter.style.display = "block";
    } else {
      this.promoMsgBefore.style.display = "block";
      this.promoMsgAfter.style.display = "none";
    }

    const percentage = ((difference / this.PROMO_THRESHOLD) * 100).toFixed(0);
    this.promoMeter.style.width = percentage > 100 ? "100%" : `${percentage}%`;
  }
}

class SideCart extends HTMLElement {
  constructor() {
    super();

    // components to initialize cart functionality
    this.cartBubble = document.querySelector("header #cart-icon-bubble");
    this.closeBtn = this.querySelector("#closecart");
    this.cartOverlay = this.querySelector(".sidecart__overlay");

    // components to be updated every time there is a cart action
    this.sidecartItems = this.querySelector(".sidecart__items .sidecart__items-wrapper");
    // this.sidecartUpsell = this.querySelector(".sidecart__upsell");
    this.cartFooter = this.querySelector(".sidecart__footer");
    this.emptyCart = this.querySelector(".sidecart__empty");
    this.shippingContainer = this.querySelector(".sidecart__shipping");
    this.shippingMsg = this.querySelector(".sidecart__shipping .shipping-msg");
    this.shippingMeterContainer = this.querySelector(".shipping-meter");
    this.shippingMeter = this.querySelector(".shipping-meter .meter-indicator");
    this.shippingIndex = this.querySelector(".shipping-index");
    this.market = this.getAttribute("market");
    this.countryCode = this.getCountryCode();
    this.sidecartItemsUpsell = this.querySelector(
      ".sidecart__items .sidecart__items-wrapper--upsell"
    );

    const promoEls = this.querySelectorAll(".sidecart__promo");
    this.promos = [];

    promoEls.forEach((promoEl) => {
      this.promos.push(new PromoBar(promoEl));
    });

    // Constants
    this.CURRENCY_SYMBOL = this.getCurrencySymbol();
    this.CARTROUTES = "/cart";
    this.FREESHIPPING = this.dataset.freeShipping;
    this.LOADINGICON = this.loadingIcon();
    this.STOCK_THE_BAR_GIFT_DEFAULT_VARIANT_ID = 43298440380615;

    // Subscribe to CartStateManager for state changes
    if (window.cartStateManager) {
      this.unsubscribe = window.cartStateManager.subscribe((newState) => {
        this.handleStateChange(newState);
      });
    }

    this.init();
  }

  disconnectedCallback() {
    // Cleanup subscription when element is removed
    if (this.unsubscribe) {
      this.unsubscribe();
    }
  }

  async init() {
    window.initCart = true;

    // Wait for CartStateManager to be available
    if (!window.cartStateManager) {
      console.error('CartStateManager not available yet, retrying...');
      setTimeout(() => this.init(), 100);
      return;
    }

    // Initialize cart state from manager
    const cartData = await window.cartStateManager.init();

    if (window.cartClickPending) {
      this.openCart();
      window.cartClickPending = false;
    }

    this.cartBubble.addEventListener("click", this.openCart.bind(this));
    this.cartBubble.addEventListener("click", (e) => {
      e.preventDefault();
      this.openCart.bind(this);
    });
    this.closeBtn.addEventListener("click", this.closeCart.bind(this));
    this.cartOverlay.addEventListener("click", this.closeCart.bind(this));

    if (market !== "united-kingdom" && market !== "europe" && market !== "australia-nz") {
      const rebuyData = await this.getRebuyData(cartData);
      this.renderItemsUpsell(rebuyData);
    }

    // Wire up Liquid-rendered bundle remove buttons
    this.initBundleRemoveButtons(cartData);
  }

  initBundleRemoveButtons(cartData) {
    this.querySelectorAll('.sc-bundle__remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        const lines = (btn.dataset.bundleLines || '').split(',').map(Number).filter(Boolean);
        if (!lines.length) return;
        const state = window.cartStateManager.getState();
        const quantities = state.items.map((item, idx) => {
          return lines.includes(idx + 1) ? 0 : item.quantity;
        });
        await this.multiupdateCart(quantities);
      });
    });
  }

  /**
   * Handle cart state changes from CartStateManager
   */
  async handleStateChange(newState, oldState) {
    // Re-render side cart with new state
    await this.reRenderCart(newState);
  }

  openCart(event) {
    this.classList.add("cart--open");
    document.querySelector("body").classList.add("overflow-hidden");
    const widget = document.querySelector("#rafaq-widget");

    if (widget) {
      widget.style.display = "none";
    }
  }

  closeCart(event) {
    event.preventDefault();
    this.classList.remove("cart--open");
    document.querySelector("body").classList.remove("overflow-hidden");
    const widget = document.querySelector("#rafaq-widget");

    if (widget) {
      widget.style.display = "block";
    }
  }

  getCurrencySymbol() {
    const url = window.location.href.toLowerCase();
    let localCurrency = "$";

    if (url.includes("en-gb")) {
      localCurrency = "£";
    } else if (url.includes("-eu")) {
      localCurrency = "€";
    } else if (url.includes("en-ca")) {
      localCurrency = "$";
    }

    return localCurrency;
  }

  // functions returning constant values
  loadingIcon() {
    return `
      <div class="loading-circle"></div>
      <style>
        .loading-circle {
          width: 70px;
          height: 70px;
          border: 5px solid transparent;
          border-top-color: #008FBB;
          border-right-color: #008FBB;
          border-bottom-color: #008FBB;
          border-radius: 50%;
          animation: spin 0.77s linear infinite;
          margin: auto;
          display: block !important;
        }
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    `;
  }
  discountIcon() {
    return `
    <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-discount color-foreground-{{ settings.accent_icons }}" viewBox="0 0 12 12">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 0h3a2 2 0 012 2v3a1 1 0 01-.3.7l-6 6a1 1 0 01-1.4 0l-4-4a1 1 0 010-1.4l6-6A1 1 0 017 0zm2 2a1 1 0 102 0 1 1 0 00-2 0z" fill="currentColor">
    </svg>
    `;
  }

  showErrorPopup(errorMessage) {
    // Suppress harmless "Cart changed" message from Cart Transform
    if (errorMessage && errorMessage.toLowerCase().includes('cart changed')) return;

    // Create popup container
    const popupContainer = document.createElement('div');
    popupContainer.style.position = 'fixed';
    popupContainer.style.top = '0';
    popupContainer.style.left = '0';
    popupContainer.style.width = '100%';
    popupContainer.style.height = '100%';
    popupContainer.style.backgroundColor = 'rgba(0, 0, 0, 0.5)';
    popupContainer.style.zIndex = '1000002';
    popupContainer.style.display = 'flex';
    popupContainer.style.justifyContent = 'center';
    popupContainer.style.alignItems = 'center';

    // Create popup content
    const popup = document.createElement('div');
    popup.style.backgroundColor = 'white';
    popup.style.padding = '20px';
    popup.style.borderRadius = '5px';
    popup.style.maxWidth = '400px';
    popup.style.textAlign = 'center';

    // Add error message
    const message = document.createElement('p');
    message.textContent = errorMessage;
    
    if (errorMessage.includes('Too many requests detected.')) {
      const [firstPart, secondPart] = errorMessage.split('Please wait a moment and try again.');
      message.innerHTML = `<strong>${firstPart}</strong>${secondPart}`;
    }

    popup.appendChild(message);

    // Add OK button
    const okButton = document.createElement('button');
    okButton.textContent = 'Okay';
    okButton.style.backgroundColor = '#0088b3';
    okButton.style.color = 'white';
    okButton.style.border = 'none';
    okButton.style.padding = '10px 40px';
    okButton.style.borderRadius = '5px';
    okButton.style.cursor = 'pointer';
    okButton.style.marginTop = '10px';
    okButton.addEventListener('click', () => {
      document.body.removeChild(popupContainer);
    });
    popup.appendChild(okButton);

    // Add popup to page
    popupContainer.appendChild(popup);
    document.body.appendChild(popupContainer);
  }

  async addToCart(itemId, quantity = 1, sellingPlan, itemProps = {}) {
    try {
      // Ensure CartStateManager is available
      if (!window.cartStateManager) {
        throw new Error('CartStateManager not initialized');
      }

      // Use CartStateManager - it will handle serialization and state updates
      await window.cartStateManager.addItem(itemId, quantity, itemProps, sellingPlan);

      // Open drawer - don't call getCart() which re-renders with potentially stale state
      // The handleStateChange callback already re-rendered with fresh state
      this.openCart();
    } catch (error) {
      console.error('Error adding to cart:', error);
      this.showErrorPopup(error.message || 'Failed to add item to cart');
    }
  }

  async addItemsToCart(items) {
    try {
      if (!window.cartStateManager) {
        throw new Error('CartStateManager not initialized');
      }

      await window.cartStateManager.addItems(items);

      // State is already refreshed by CartStateManager.processQueue
      // The subscribe -> handleStateChange callback has already re-rendered
      this.openCart();
    } catch (error) {
      console.error('Error adding items to cart:', error);
      this.showErrorPopup(error.message || 'Failed to add items to cart');
    }
  }

  async addSubscriptionsToCart(items) {
    const updates = {
      items: items.map((item) => {
        return {
          quantity: item.quantity,
          selling_plan: item.selling_plan,
          id: item.id,
          properties: item.property,
        };
      }),
    };
    const properties = {
      ...fetchConfig("javascript"),
      body: JSON.stringify(updates),
    };

    try {
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", properties);
      const data = await response.json();

      if (response.status !== 200) {
        this.showErrorPopup(data.message || data.description);
        return;
      }

      // get the cart data
      await this.getCart();
    } catch (err) {
      console.error(err);
    }
  }

  // getCart() - Preserves original behavior: re-render and open drawer
  async getCart() {
    // Get current state from CartStateManager (already updated by previous operations)
    const cartData = window.cartStateManager.getState();

    // Re-render cart with current state
    await this.reRenderCart(cartData);

    // Open drawer (preserves original behavior)
    this.openCart();

    return cartData;
  }

  async multiupdateCart(lineQuantities) {
    try {
      await window.cartStateManager.updateCart(lineQuantities);
      // State change will trigger handleStateChange automatically
    } catch (error) {
      console.error("Error while updating - multiupdateCart", error);
      this.showErrorPopup(error.message || 'Failed to update cart');
      return null;
    }
  }

  async updateCart(lineIndex, quantity) {
    try {
      // Use CartStateManager to update quantity
      await window.cartStateManager.updateQuantity(lineIndex, quantity);
      // State change will trigger handleStateChange automatically
    } catch (error) {
      console.error("Error while updating - updateCart", error);
      this.showErrorPopup(error.message || 'Failed to update cart');
      return null;
    }
  }

  async reRenderCart(cartData) {
    const headerIcons = document.querySelector(".header__icons");
    const shopNowButton = headerIcons?.querySelector(".btn--shop-all");
    if (shopNowButton && !headerIcons.classList.contains("has-cart-item")) {
      headerIcons.classList.add("has-cart-item");
    }

    const itemCount = cartData.item_count;

    // CartStateManager now handles event dispatching - no need for _suppressEvents flag

    if (itemCount === 0) {
      this.cartFooter.innerHTML = "";
      if (this.sidecartItems) {
        this.sidecartItems.innerHTML = "";
      }
      this.emptyCart.innerHTML = this.renderEmptyCart();
      this.sidecartItemsUpsell.innerHTML = "";
    } else {
      this.emptyCart.innerHTML = "";
      await this.renderItems(cartData);

      if (market !== "united-kingdom" && market !== "europe" && this.market !== "australia-nz") {
        this.getRebuyData(cartData).then(rebuyData => {
          this.renderItemsUpsell(rebuyData);
        });
      }

      this.cartFooter.innerHTML = this.renderFooter(cartData);

      const excludedProductIds = [7519374901447, 8035822534855, 8773255692487];
      // const excludedProductIds = [];

      if (
        cartData.items.length > 0 &&
        cartData.items.every(item => excludedProductIds.includes(item.product_id))
      ) {
        isShippingProtectionAvailable = false;
      } else {
        isShippingProtectionAvailable = true;
      }

      if (!isShippingProtectionAvailable) {
        if (document.querySelector("shipping-protection")) {
          document.querySelector("shipping-protection").removeProtectionProduct();
        }
      }
    }

    this.reRenderShipping(cartData);

    this.promos.forEach((promo) => {
      promo.reRender(cartData);
    });

    const cartCountBubbles = document.querySelectorAll(".cart-count-bubble");
    cartCountBubbles.forEach((cartCountBubble) => {
      cartCountBubble.innerHTML = this.reRenderBubble(itemCount);
    });
  }

  getCountryCode() {
    switch (this.market) {
      case 'united-kingdom':
        return 'GB';
      case 'europe':
        return '';
      case 'australia-nz':
        return 'AU';
      case 'ca':
        return 'CA';
    }
    return 'US';
  }

  async getVariantById(variantId) {
    try {
      const response = await fetch(`/variants/${variantId}.js`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching variant details:', error);
      return null;
    }
  }

  async getProductPrice(shopifyID) {
    if (!shopifyID || !this.countryCode) return null;
    const query = `query ProductPricesByCountry($productId: ID!) @inContext(country: ${this.countryCode}) {
      product(id: $productId) {
        id
        title
        handle
        variants(first: 10) {
          edges {
            node {
              id
              title
              price {
                amount
                currencyCode
              }
              compareAtPrice {
                amount
                currencyCode
              }
            }
          }
        }
      }
    }
    `

    try {
      const response = await fetch('https://bartesianshop.myshopify.com/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': "d2ac5e3582a169a988fb3ab7f875f217"
        },
        body: JSON.stringify({
          query,
          variables: {
            productId: shopifyID
          }
        })
      })

      const data = await response.json();
      return data;
    } catch (e) {
      return null
    }

  }

  async getProductByHandle(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      return await response.json();
    } catch (error) {
      console.error('Error fetching variant details:', error);
      return null;
    }
  }

  async renderItems(cartData) {
    // this executes if the cart is empty (only initial page load)
    if (!this.sidecartItems) {
      this.querySelector(
        ".sidecart__items"
      ).innerHTML = `<div class="sidecart__items-wrapper"></div><div class="sidecart__items-wrapper--upsell"></div>`;
    }
    // reinitialize sidecartItems
    this.sidecartItems = this.querySelector(".sidecart__items .sidecart__items-wrapper");

    const discountIcon = this.discountIcon();

    let currentMarket = "";

    switch (cartData.currency) {
      case "USD":
        currentMarket = "us";
        break;
      case "CAD":
        currentMarket = "ca";
        break;
      case "GBP":
        currentMarket = "united-kingdom";
        break;
      default:
        currentMarket = "europe";
        break;
    }

    // ── Bundle Grouping (Side Cart JS) ──────────────────────────
    // Renders bundle items as a single visual card with grouped sections,
    // savings badge, and "Remove Bundle" button.
    //
    // For merged bundles (Cart Transform), the AJAX cart API does not expose
    // item_components, so we fetch server-rendered HTML via the Section
    // Rendering API (GET /?sections=side-cart) which has Liquid access to
    // item_components. Falls back to showing parent product with summary text.
    //
    // For legacy multi-line bundles, items are grouped by _bundleId and
    // rendered by role (_bundleRole or product_type fallback).
    //
    // Related: sections/side-cart.liquid, assets/component-side-cart-bundle.css
    // ──────────────────────────────────────────────────────────────
    const bundleGroups = {};
    const regularItems = [];

    cartData.items.forEach((itemData, index) => {
      const props = itemData.properties || {};
      const bundleId = props['_bundleId'] || props['_bundle-id'];
      if (bundleId) {
        if (!bundleGroups[bundleId]) {
          bundleGroups[bundleId] = { items: [] };
        }
        bundleGroups[bundleId].items.push({ data: itemData, lineIndex: index + 1 });
      } else {
        regularItems.push({ data: itemData, index });
      }
    });

    // ── Check if any bundle uses merged model (has_components) ──────
    const hasMergedBundles = Object.values(bundleGroups).some(group => {
      const firstItem = group.items[0].data;
      const firstProps = firstItem.properties || {};
      return firstItem.has_components || firstProps['_bundleProductCount'];
    });

    // If merged bundles exist, fetch server-rendered HTML via Section Rendering API
    // because the AJAX cart API does not expose item_components
    let serverBundleHTML = '';
    if (hasMergedBundles) {
      try {
        const sectionRes = await fetch(window.Shopify.routes.root + '?sections=side-cart');
        if (!sectionRes.ok) throw new Error('Section fetch failed');
        const sectionData = await sectionRes.json();
        const sectionHTML = sectionData['side-cart'] || '';
        const parser = new DOMParser();
        const doc = parser.parseFromString(sectionHTML, 'text/html');
        const bundleHeaders = doc.querySelectorAll('.sc-bundle__header');
        const bundleCards = doc.querySelectorAll('.sc-bundle');
        for (let i = 0; i < bundleHeaders.length; i++) {
          serverBundleHTML += bundleHeaders[i].outerHTML;
          if (bundleCards[i]) serverBundleHTML += bundleCards[i].outerHTML;
        }
      } catch (e) {
        console.warn('[bundle] Section rendering fallback:', e);
      }
    }

    // ── Render bundle groups as plain HTML ──────────────────────────
    let bundleHTML = '';
    if (serverBundleHTML) {
      // Use server-rendered bundle HTML (has item_components)
      bundleHTML = serverBundleHTML;
    } else {
    for (const [bundleId, group] of Object.entries(bundleGroups)) {
      const lineIndices = group.items.map(i => i.lineIndex);
      const firstItem = group.items[0].data;
      const firstProps = firstItem.properties || {};

      // Merged bundle (single line item with has_components)
      const isMergedBundle = firstItem.has_components || firstProps['_bundleProductCount'];

      let pct, savings, bundleCost, bundleOriginal, sectionsHTML;

      if (isMergedBundle) {
        // Fallback: AJAX cart API does not expose item_components
        bundleOriginal = firstItem.original_line_price;
        bundleCost = firstItem.final_line_price;
        savings = firstItem.total_discount || (bundleOriginal - bundleCost);
        // Use the discount allocation percentage if available (exact tier value)
        const discountAlloc = (firstItem.line_level_discount_allocations || [])
          .find(da => da.discount_application?.value_type === 'percentage');
        pct = discountAlloc
          ? Math.round(parseFloat(discountAlloc.discount_application.value))
          : (bundleOriginal > 0 ? Math.round((savings / bundleOriginal) * 100) : 0);

        const productCount = parseInt(firstProps['_bundleProductCount'] || '0', 10);
        const machineCount = parseInt(firstProps['_machineCount'] || '0', 10);
        const accessoryCount = parseInt(firstProps['_accessoryCount'] || '0', 10);

        let summaryParts = [];
        if (machineCount > 0) summaryParts.push(`${machineCount} Cocktail Maker${machineCount > 1 ? 's' : ''}`);
        if (productCount > 0) summaryParts.push(`${productCount} Cocktail Box${productCount > 1 ? 'es' : ''}`);
        if (accessoryCount > 0) summaryParts.push(`${accessoryCount} Accessor${accessoryCount > 1 ? 'ies' : 'y'}`);

        sectionsHTML = `
          <div class="sc-bundle__item">
            <div class="sc-bundle__item-img">
              <img src="${this.initImageSize(firstItem.image)}" alt="${firstItem.product_title || ''}">
            </div>
            <div class="sc-bundle__item-info">
              <p class="sc-bundle__item-name">${firstItem.product_title}</p>
              ${summaryParts.length ? `<p class="sc-bundle__item-summary">${summaryParts.join(' · ')}</p>` : ''}
            </div>
          </div>
          <hr class="sc-bundle__divider">`;
      } else {
        // Legacy multi-line bundle — group by role
        const getRoleValue = (i) => {
          const props = i.data.properties || {};
          if (props['_bundleRole']) return props['_bundleRole'];
          if (i.data.product_type === 'Cocktail Dispensers') return 'machine';
          if (i.data.product_type === 'Cocktails') return 'bundleProduct';
          if (i.data.product_type === 'Accessories') return 'accessory';
          return '';
        };
        const makers = group.items.filter(i => getRoleValue(i) === 'machine');
        const capsules = group.items.filter(i => getRoleValue(i) === 'bundleProduct');
        const accessories = group.items.filter(i => getRoleValue(i) === 'accessory');
        const other = group.items.filter(i => {
          const role = getRoleValue(i);
          return role !== 'machine' && role !== 'bundleProduct' && role !== 'accessory';
        });

        bundleOriginal = group.items.reduce((sum, i) => sum + i.data.original_line_price, 0);
        const bundleFinal = group.items.reduce((sum, i) => sum + i.data.final_line_price, 0);
        const actualSavings = bundleOriginal - bundleFinal;

        if (actualSavings > 0) {
          savings = actualSavings;
          bundleCost = bundleFinal;
          pct = Math.round((savings / bundleOriginal) * 100);
        } else {
          const metaPct = parseInt(firstProps['_bundlePct'] || firstProps['_bundle-pct'] || '0', 10);
          pct = metaPct;
          savings = Math.round(bundleOriginal * metaPct / 100);
          bundleCost = bundleOriginal - savings;
        }

        const renderBundleItem = (i) => {
          const d = i.data;
          return `<div class="sc-bundle__item">
            <div class="sc-bundle__item-img">
              <img src="${this.initImageSize(d.image)}" alt="${d.product_title || ''}">
            </div>
            <div class="sc-bundle__item-info">
              <p class="sc-bundle__item-name">${d.product_title}</p>
            </div>
          </div>`;
        };

        const renderSection = (label, items) => {
          if (!items.length) return '';
          return `<p class="sc-bundle__section-label">${label}</p>${items.map(renderBundleItem).join('')}<hr class="sc-bundle__divider">`;
        };

        sectionsHTML = `
          ${renderSection('Cocktail Maker', makers)}
          ${renderSection('Cocktail Boxes', capsules)}
          ${renderSection('Accessories', accessories)}
          ${renderSection('', other)}`;
      }

      bundleHTML += `
        <div class="sc-bundle__header">
          <p class="sc-bundle__title">Your Bundle</p>
          <button class="sc-bundle__remove" data-bundle-lines="${lineIndices.join(',')}" type="button">Remove Bundle</button>
        </div>
        <div class="sc-bundle" data-bundle-id="${bundleId}" data-bundle-lines="${lineIndices.join(',')}">
          ${pct > 0 ? `<span class="sc-bundle__badge">${pct}% <strong>Savings Unlocked</strong></span>` : ''}
          ${sectionsHTML}
          <div class="sc-bundle__footer">
            <div class="sc-bundle__footer-row sc-bundle__footer-row--pct">
              <span class="sc-bundle__footer-pct">${pct}%</span>
            </div>
            <div class="sc-bundle__footer-row">
              <p class="sc-bundle__footer-label">Bundle Savings</p>
              <p class="sc-bundle__footer-value">-${this.CURRENCY_SYMBOL}${(savings / 100).toFixed(2)}</p>
            </div>
            <div class="sc-bundle__footer-row">
              <p class="sc-bundle__footer-label">Bundle Cost</p>
              <p class="sc-bundle__footer-value">${this.CURRENCY_SYMBOL}${(bundleCost / 100).toFixed(2)}</p>
            </div>
          </div>
        </div>`;
    }
    } // end else (no serverBundleHTML)

    // ── Render regular items ──────────────────────────
    const newItemsHTML = await Promise.all(regularItems.map(async ({ data: itemData, index }) => {
      const variant = await this.getVariantById(itemData.variant_id);

      function setNumCapsulesPerBox(itemData) {
        const capsuleCounts = {
          7697851908295: 6, // Classic Collection Favorites Variety Pack (USA & Canada)
          7701507276999: 6, // Classic Collection Favorites Variety Pack (UK)
          8035822534855: 12, // 2024 Advent Calendar
          8773255692487: 12, // 2026 Advent Calendar Test
          7519374901447: 12, // 2024 Advent Calendar Test
          8166638452935: 4, // Cocktail Sampler Variety Pack
        };

        itemData.properties._numCapsulesPerBox = capsuleCounts[itemData.product_id] || 8;
      }

      function handleCocktailItem(itemData) {
        itemData.properties._showModifiedPricing = true;
        itemData.properties._modifiedPricing = itemData.price;
        setNumCapsulesPerBox(itemData);
        // console.log("sidecart rebuy upsell cocktail capsules");
      }

      if (itemData.product_type === "Cocktails" && itemData.properties) {
        if (itemData.properties._source === "Rebuy") {
          handleCocktailItem(itemData);
        } else if (!itemData.properties._source) {
          handleCocktailItem(itemData);
        }
      } else if (itemData.product_type === "Accessories" && itemData.properties) {
        // console.log("sidecart rebuy upsell accessories");
      } else {
        // console.log("default case");
      }

      const matchedEarlyAccessObject = earlyAccessData.find(
        (item) => item.earlyAccessVariantId == itemData.variant_id
      );

      if (!itemData.properties) {
        itemData.properties = {};
      }
      return `
		<side-cart-item data-market="${currentMarket}" data-variant-id="${itemData.id}"
		  data-line-index="${index + 1}"
		  data-key="${itemData.key}"
		  ${Object.keys(itemData.properties).length !== 0
          ? `data-bundle-id="${itemData.properties.bundle_id ? itemData.properties.bundle_id : ""}"`
          : ""
        }>
          <div class="action-loading">
            ${this.LOADINGICON}
          </div>
          <div class="sidecart-container">
            <div class="sidecart__img">
              <img src=" ${this.initImageSize(itemData.image)}">
            </div>
            <div class="sidecart__info">
              <div class="sidecart__info-titlesection">
              ${itemData.id === this.STOCK_THE_BAR_GIFT_DEFAULT_VARIANT_ID
          ? `
                      <p class="item-title">${itemData.product_title}</p>
                      ${itemData.properties._showModifiedPricing === true &&
            itemData.properties._modifiedPricing !== "" &&
            itemData.properties._numCapsulesPerBox > 0
            ? ""
            : `${itemData.variant_title && itemData.variant_title !== "Default Title"
              ? `<p class="item-variant-title">${itemData.variant_title}</p>`
              : ""
            }`
          }
                    `
          : `<a class="item-title" href="${itemData.url}">${itemData.product_title}</a>
                      ${itemData.properties._showModifiedPricing === true &&
            itemData.properties._modifiedPricing !== "" &&
            itemData.properties._numCapsulesPerBox > 0
            ? ""
            : `${itemData.variant_title && itemData.variant_title !== "Default Title"
              ? `<p class="item-variant-title">${itemData.variant_title}</p>`
              : ""
            }`
          }`
        }
                ${itemData.selling_plan_allocation
          ? `<small>${itemData.selling_plan_allocation.selling_plan.name}</small>`
          : ""
        }
              </div>

              ${itemData.properties._showModifiedPricing === true &&
          itemData.properties._modifiedPricing !== "" &&
          itemData.properties._numCapsulesPerBox > 0
          ? ""
          : itemData.final_price != 0 || itemData.discounts.length != 0
            ? `<div class="sidecart__info-pricing">
                      <p class="item-price">
                      <span class="money">
                        ${this.CURRENCY_SYMBOL}${(itemData.final_price / 100).toFixed(2)}
                      </span>
                      </p>
                    </div>`
            : ""
        }
              ${variant.compare_at_price && variant.compare_at_price > itemData.final_price
          ? `<div class="sidecart__info-pricing">
                  <p class="item-compare-price">
                    <span class="money">${this.CURRENCY_SYMBOL}${(
            variant.compare_at_price / 100
          ).toFixed(2)}
                    </span></p>
                </div>`
          : ``
        }
              ${itemData.properties._showModifiedPricing === true &&
          itemData.properties._modifiedPricing !== "" &&
          itemData.properties._numCapsulesPerBox > 0
          ? `<div class="side-cart-bartesian-pricing-wrapper">
                      <span class="item-data-price-detail small">
                        ${this.CURRENCY_SYMBOL}${(
            itemData.final_price /
            100 /
            itemData.properties._numCapsulesPerBox
          ).toFixed(2)} ${window.cartStrings.perCapsule}
                      </span>
                      <div class="sidecart__info-pricing">
                        <p class="item-price">${this.CURRENCY_SYMBOL}${(itemData.final_price / 100).toFixed(2)} ${window.cartStrings.perBox}</p>
                      </div>
                      <span class="item-desc-capsules small">${itemData.properties._numCapsulesPerBox
          } / ${window.cartStrings.capsules}</span>
                    </div>`
          : ""
        }
            </div>
            <div class="sidecart__buttons">
              ${itemData.final_price != 0 || itemData.discounts.length != 0
          ? `
                <a class="item-remove qty-controller" data-update-type="remove">${window.cartStrings.remove
          }</a>`
          : ""
        }
              ${itemData.selling_plan_allocation
          ? `<div class="sidecart__qty-control sidecart__qty-control--subscription">
                <span class="itemQty-display" style="display: inline-flex;">${itemData.quantity}</span>
              </div>`
          : `<div class="sidecart__qty-control">
                <button class="btn item-qty-btn qty-controller" data-update-type="minus">−</button>
                <input style="height: 30px; width: 30px;" class="itemQty" id="itemQty" type="number" value="${itemData.quantity}" disabled />
                <button class="btn item-qty-btn qty-controller" data-update-type="plus" ${qtyLimitEnabled &&
            matchedEarlyAccessObject &&
            itemData.quantity >= matchedEarlyAccessObject.earlyAccessProductQtyLimit &&
            matchedEarlyAccessObject.earlyAccessProductQtyLimit > 0
            ? "disabled"
            : ""
          }>+</button>
              </div>`
        }
            </div>
          </div>
                    ${itemData.discounts &&
          itemData.discounts.length > 0
          ? `<ul class="item-discounts">
              ${itemData.discounts
            .map((discount) => {
              return `
                  <li>
                    ${discountIcon}
                    <span class="discount-info">
                      ${discount.title}(-${this.CURRENCY_SYMBOL}${(
                  discount.amount / 100
                ).toFixed(2)})
                    </span>
                  </li>`;
            })
            .join("")}
            </ul>`
          : ""
        }
        </side-cart-item>
      `;
    }));

    this.sidecartItems.innerHTML = bundleHTML + newItemsHTML.join("");

    // ── Wire up bundle remove buttons ──────────────────────────
    this.sidecartItems.querySelectorAll('.sc-bundle__remove').forEach(btn => {
      btn.addEventListener('click', async () => {
        const lines = btn.dataset.bundleLines.split(',').map(Number);
        const currentState = window.cartStateManager.getState();
        const quantities = currentState.items.map((item, idx) => {
          return lines.includes(idx + 1) ? 0 : item.quantity;
        });
        await this.multiupdateCart(quantities);
      });
    });
  }

  initImageSize(src) {
    if (src) {
      if (
        src.includes(".png") ||
        src.includes(".PNG") ||
        src.includes(".jpg") ||
        src.includes(".jpg")
      ) {
        const lastIndex = src.lastIndexOf(".");
        const before = src.slice(0, lastIndex);

        const after = src.slice(lastIndex + 1);

        const newSrc = before + "_150x." + after;
        return newSrc;
      } else {
        return src;
      }
    } else {
      return "https://cdn.shopify.com/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_200x.gif";
    }
  }

  renderOptions(v) {
    // let dataPrice = v.presentment_prices?.find(
    //   (price) => price.price.currency_code === currencyCode
    // ).price.amount;
    let isCapsule = v.title.toLowerCase().includes("capsules") ? true : false;
    let dataPrice = v.price;

    if (v.title == "32 Capsules" || v.title == "36 Capsules") {
      if (v.inventory_quantity > 0) {
        return `<option value="${v.id}" class="large_package" data-price="${v.price}">${v.title}</option>`;
      } else {
        return `<option disabled value="${v.id}" class="large_package" data-price="${v.price}">${v.title}</option>`;
      }
    } else {
      if (v.inventory_quantity > 0 || v.inventory_management == null) {
        let currencyCode = "";

        switch (this.market) {
          case "us":
            currencyCode = "USD";
            break;
          case "ca":
            currencyCode = "CAD";
            break;
          case "united-kingdom":
            currencyCode = "GBP";
            break;
          case "europe":
            currencyCode = "EUR";
            break;
          default:
            break;
        }

        return `<option value="${v.id}" data-product-type=${isCapsule ? "cocktails" : "non-cocktails"
          } data-price="${dataPrice}">${v.title}</option>`;
      } else {
        return `<option disabled value="${v.id}" data-product-type=${isCapsule ? "cocktails" : "non-cocktails"
          } data-price="${dataPrice}">${v.title}</option>`;
      }
    }
  }

  renderOptionAdventCalendar(v) {
    if (v.inventory_quantity > 0) {
      return `<option value="${v.id}" data-price="${v.price}">${v.title}</option>`;
    } else {
      return `<option disabled value="${v.id}" data-price="${v.price}">${v.title}</option>`;
    }
  }

  variantsLocalization(variants) {
    let isVariantsHas6or36 = false;
    variants.forEach((v) => {
      if (v.title == "6 Capsules" || v.title == "36 Capsules") {
        if (v.inventory_quantity > 0) {
          isVariantsHas6or36 = true;
        }
      }
    });
    return variants.map((v) => {
      if (window.geolocation == "Canada") {
        if (v.title == "8 Capsules" || v.title == "32 Capsules") {
          return this.renderOptions(v);
        } else {
          return this.renderOptions(v);
        }
      } else {
        if (isVariantsHas6or36) {
          if (v.title == "6 Capsules" || v.title == "36 Capsules") {
            return this.renderOptions(v);
          }
        } else {
          return this.renderOptions(v);
        }
      }
    });
  }

  async renderItemsUpsell(rebuyData) {
    // reinitialize sidecartItems
    this.sidecartItemsUpsell = this.querySelector(
      ".sidecart__items .sidecart__items-wrapper--upsell"
    );
    if (!rebuyData.data || rebuyData.data.length == 0) {
      return this.sidecartItemsUpsell.innerHTML = "";
    }

    const productIds = []

    //get rebuy variant
    const variantIds = rebuyData.data.map((itemData, index) => {
      productIds.push(itemData.admin_graphql_api_id);

      const variantTitles = earlyAccessProductIds.includes(itemData.id) ? ["12 Capsules"] : ["8 Capsules"];
      for (let title of variantTitles) {
        const variant = itemData.variants.find((variant) => variant.title.includes(title));
        if (variant) return variant.admin_graphql_api_id
      }

      return itemData.variants[0].admin_graphql_api_id
    });

    const resVariants = []
    const graphqlProducts = await Promise.all(productIds.map(async id => {
      const res = await this.getProductPrice(id);
      return res?.data?.product;
    }));

    graphqlProducts.map(product => {
      const variants = product?.variants?.edges?.map(vrt => vrt?.node);
      if (!variants) return;
      resVariants.push(...variants);
    });

    const variants = resVariants.filter(vrt => variantIds.includes(vrt.id));
    const filteredRebuyData = rebuyData.data.filter(itemData => {
      const itemDataVariantIds = itemData.variants.map(itemDataVariant => itemDataVariant.admin_graphql_api_id);
      return variants.some(vrt => itemDataVariantIds.includes(vrt.id));
    });

    if (filteredRebuyData.length == 0) return this.sidecartItemsUpsell.innerHTML = "";

    const newItemsHTML = filteredRebuyData.map((itemData, index) => {
      // const getVariantPrice = (itemData, variantTitles, currencyCode) => {
      // for (let title of variantTitles) {
      //   const variant = itemData.variants.find((variant) => variant.title.includes(title));
      //   if (variant) {

      //     const priceObj = variant.presentment_prices.find(
      //       (price) => price.price.currency_code === currencyCode
      //     );
      //     if (priceObj) return priceObj.price.amount;
      //   }
      // }

      // return itemData.variants[0]?.presentment_prices.find(
      //   (price) => price.price.currency_code === currencyCode
      // )?.price.amount;
      // };

      // const variantTitlesForUSD = earlyAccessProductIds.includes(itemData.id)
      //   ? ["12 Capsules"]
      //   : ["8 Capsules"];
      // const rebuyItemUSD = getVariantPrice(itemData, variantTitlesForUSD, "USD");

      // const variantTitlesForCAD = earlyAccessProductIds.includes(itemData.id)
      //   ? ["12 Capsules"]
      //   : ["8 Capsules"];
      // const rebuyItemCAD = getVariantPrice(itemData, variantTitlesForCAD, "CAD");
      const itemDataVariantIds = itemData.variants.map(itemDataVariant => itemDataVariant.admin_graphql_api_id);
      const variant = variants.find(vrt => {
        return itemDataVariantIds.includes(vrt.id)
      });

      const rebuyItemUSD = variant?.price?.amount;
      const rebuyItemCAD = variant?.price?.amount;
      if (!itemData.properties) {
        itemData.properties = {};
      }

      function setNumCapsulesPerBox(itemData) {
        const capsuleCounts = {
          7697851908295: 6, // Classic Collection Favorites Variety Pack (USA & Canada)
          7701507276999: 6, // Classic Collection Favorites Variety Pack (UK)
          8035822534855: 12, // 2024 Advent Calendar
          8773255692487: 12, // 2026 Advent Calendar Test
          7519374901447: 12, // 2024 Advent Calendar Test
          8166638452935: 4, // Cocktail Sampler Variety Pack
        };

        itemData.properties._numCapsulesPerBox = capsuleCounts[itemData.id] || 8;
      }

      setNumCapsulesPerBox(itemData);
      let capsulePrice = window.geolocation === "Canada" ? rebuyItemCAD : rebuyItemUSD;

      return `
        <div class="swiper-slide">
          <side-cart-item-upsell data-variant-id="${itemData.id}">
            <div class="action-loading">${this.LOADINGICON}</div>
            <div class="sidecart__img">
              <img src="${this.initImageSize(itemData.image.src)}">
            </div>
            <div class="sidecart__info">
              <div class="sidecart__info-titlesection">
                <a class="item-title rebuy-title" href="${itemData.link}" onclick="event.stopPropagation();">${itemData.title}</a>
                ${itemData.product_type === "Cocktails" &&
          itemData.properties._numCapsulesPerBox > 0
          ? `<span class="item-data-price-detail small">$${(
            capsulePrice / itemData.properties._numCapsulesPerBox
          ).toFixed(2)} ${window.cartStrings.perCapsule}</span>`
          : ``
        }
              </div>
              <div class="sidecart__info-pricing">
                <p class="item-price">$${Number(capsulePrice)?.toFixed(2)
        }</p>
              </div>
              ${variant?.compare_at_price?.amount && variant?.compare_at_price?.amount > variant?.price?.amount
          ? `<div class="sidecart__info-pricing">
                  <p class="item-compare-price">
                    <span class="money">${this.CURRENCY_SYMBOL}${Number(variant?.compare_at_price?.amount).toFixed(2)
          }
                    </span></p>
                </div>`
          : ``
        }
            </div>
            <div class="sidecart__buttons">
              <button type="button" class="upsell-act">
                  +
              </button>
            </div>
            <div class="sidecart__variants">
              <select class="variants__select">
                ${earlyAccessProductIds.includes(itemData.id)
          ? this.renderOptionAdventCalendar(itemData.variants[0])
          : this.variantsLocalization(itemData.variants)
        }
              </select>
            </div>
          </side-cart-item-upsell>
        </div>
      `;
    });

    const storeLocale = window.Shopify.locale;
    const titleHTML = `<h3 class="title">${window.cartStrings.youMayAlsoLike
      }:</h3>`;

    this.sidecartItemsUpsell.innerHTML = `
      ${titleHTML}
        <div id="side-cart-swiper-button-prev" class="swiper-button-prev">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="17" cy="17" r="17" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M20.6769 9.2611C20.7794 9.34365 20.8606 9.44173 20.916 9.5497C20.9715 9.65767 21 9.77343 21 9.89033C21 10.0072 20.9715 10.123 20.916 10.2309C20.8606 10.3389 20.7794 10.437 20.6769 10.5196L12.6564 17.0002L20.6769 23.4809C20.8834 23.6478 20.9994 23.8741 20.9994 24.1101C20.9994 24.3461 20.8834 24.5725 20.6769 24.7394C20.4705 24.9062 20.1904 25 19.8984 25C19.6064 25 19.3264 24.9062 19.1199 24.7394L10.3231 17.6295C10.2206 17.5469 10.1394 17.4488 10.084 17.3409C10.0285 17.2329 10 17.1171 10 17.0002C10 16.8833 10.0285 16.7676 10.084 16.6596C10.1394 16.5516 10.2206 16.4536 10.3231 16.371L19.1199 9.2611C19.2221 9.17833 19.3434 9.11267 19.477 9.06787C19.6106 9.02306 19.7538 9 19.8984 9C20.0431 9 20.1863 9.02306 20.3199 9.06787C20.4535 9.11267 20.5748 9.17833 20.6769 9.2611Z" fill="#353538"/>
          </svg>
        </div>
        <div class="swiper sidecart-swiper">
          <div class="swiper-wrapper">
            ${newItemsHTML.join("")}
          </div>
          <div class="swiper-pagination"></div>
        </div>
        <div id="side-cart-swiper-button-next" class="swiper-button-next">
          <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="17" cy="17" r="17" fill="white"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M13.3231 9.2611C13.2206 9.34365 13.1394 9.44173 13.084 9.5497C13.0285 9.65767 13 9.77343 13 9.89033C13 10.0072 13.0285 10.123 13.084 10.2309C13.1394 10.3389 13.2206 10.437 13.3231 10.5196L21.3436 17.0002L13.3231 23.4809C13.1166 23.6478 13.0006 23.8741 13.0006 24.1101C13.0006 24.3461 13.1166 24.5725 13.3231 24.7394C13.5295 24.9062 13.8096 25 14.1016 25C14.3936 25 14.6736 24.9062 14.8801 24.7394L23.6769 17.6295C23.7794 17.5469 23.8606 17.4488 23.916 17.3409C23.9715 17.2329 24 17.1171 24 17.0002C24 16.8833 23.9715 16.7676 23.916 16.6596C23.8606 16.5516 23.7794 16.4536 23.6769 16.371L14.8801 9.2611C14.7779 9.17833 14.6566 9.11267 14.523 9.06787C14.3894 9.02306 14.2462 9 14.1016 9C13.9569 9 13.8137 9.02306 13.6801 9.06787C13.5465 9.11267 13.4252 9.17833 13.3231 9.2611Z" fill="#353538"/>
          </svg>
        </div>
      </div>
    `;

    // Initialize Swiper
    new Swiper(".sidecart-swiper", {
      slidesPerView: 1,
      spaceBetween: 30,
      navigation: {
        nextEl: "#side-cart-swiper-button-next",
        prevEl: "#side-cart-swiper-button-prev",
      },
      loop: true,
    });
  }

  loadingRebuy() {
    this.sidecartItemsUpsell = this.querySelector(
      ".sidecart__items .sidecart__items-wrapper--upsell"
    );
    this.sidecartItemsUpsell.innerHTML = `<div class="action-loading loading">${this.LOADINGICON}</div>`
  }

  async getRebuyData(cartData) {
    const key = "e54e41d40abdf5a0fd05b86ef91ad8cfe7e3c9c4";

    let product_ids_array = [];
    for (let i = 0; i < cartData.items.length; i++) {
      product_ids_array.push(cartData.items[i].product_id);
    }
    let product_ids = product_ids_array.join(",");
    if (!product_ids) product_ids = "4756369702961";

    // https://pthree.atlassian.net/browse/BAR-654
    // let dataSourceId = market === "ca" ? "172060" : "58594";
    let dataSourceId = "58594";

    if (this.sidecartItemsUpsell.childNodes.length === 0) {
      this.loadingRebuy();
    }
    const response = await fetch(
      `https://rebuyengine.com/api/v1/custom/id/${dataSourceId}?shopify_product_ids=${product_ids}&format=pretty&key=${key}&country_code=${this.market}`
    );
    const data = await response.json();
    return data;
  }

  async getUpsellData(cartData, cartDataProducts) {
    let upsell_1, upsell_2;
    for (let i = 0; i < cartData.items.length; i++) {
      const item = cartData.items[i];
      const itemProduct = cartDataProducts[i];

      // breaks the loop if both upsell_1 and upsell_2 are reserved
      if (upsell_1 && upsell_2) {
        break;
      } else {
        if (itemProduct.tags.includes("upsell product")) {
          for (let j = 0; j < itemProduct.tags.length; j++) {
            const tag = itemProduct.tags[j];
            if (tag.includes("upsell_")) {
              const upsell_handle = tag.split("upsell_")[1];
              if (!upsell_1)
                upsell_1 = await fetch(`/products/${upsell_handle}.js`).then((response) =>
                  response.json()
                );
              else if (!upsell_2 && upsell_handle !== upsell_1.handle)
                upsell_2 = await fetch(`/products/${upsell_handle}.js`).then((response) =>
                  response.json()
                );
            }
          }
        }
      }
    }

    return [upsell_1, upsell_2];
  }

  renderUpsell(upsellData) {
    const upsell_1 = upsellData[0],
      upsell_2 = upsellData[1];
    const upsellHTML =
      upsell_1 || upsell_2
        ? `
      <div class="sidecart__upsell-wrapper">
        <div class="sidecart__upsell-header">
          <p>You'll also love</p>
        </div>
        <div class="sidecart__upsell-body">
          ${upsell_1
          ? `
            <div class="sidecart__upsell-product">
              <div class="product_info">
                <div class="img_container">
                  <img src="${upsell_1.featured_image}">
                </div>
                <p class="prod_title">${upsell_1.title}</p>
                <p class="prod_price">${parseFloat(upsell_1.price / 100).toFixed(2)}</p>
              </div>
              <upsell-button>
                <a class="upsell-button button button--primary" data-variant-id="${upsell_1.variants[0].id
          }">Add to Cart</a>
              </upsell-button>
            </div>
          `
          : ""
        }
          ${upsell_2
          ? `
            <div class="sidecart__upsell-product">
              <div class="product_info">
                <div class="img_container">
                  <img src="${upsell_2.featured_image}">
                </div>
                <p class="prod_title">${upsell_2.title}</p>
                <p class="prod_price">${parseFloat(upsell_2.price / 100).toFixed(2)}</p>
              </div>
              <upsell-button>
                <a class="upsell-button button button--primary" data-variant-id="${upsell_2.variants[0].id
          }">Add to Cart</a>
              </upsell-button>
            </div>
          `
          : ""
        }
        </div>
      </div>
    `
        : "";

    this.sidecartUpsell.innerHTML = upsellHTML;
  }

  renderFooter(cartData) {
    for (let item of cartData.items) {
      if (
        item.gift_card ||
        item.product_type === "Cocktail Dispensers" ||
        item.product_type === "Bundle"
      ) {
        isShippingProtectionAvailable = false;
        break;
      } else {
        isShippingProtectionAvailable = true;
      }
    }

    const updatedFooterHTML = `
    ${shippingProductionActive
        ? `
          <shipping-protection>
            ${isShippingProtectionAvailable
          ? `
              <span slot='price' style='margin-left: 4px;'>$2.75</span>
              <span slot="tooltip" style="margin-left: 4px; padding: 8px;">
                <span aria-describedby="shipping-protection-details" part="describedby">
                  <svg aria-hidden="true" focusable="false" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024">
                    <path d='M511.51393 63.894216c-114.5315 0-229.061976 43.508933-316.720432 131.167389-174.676321 174.676321-174.676321 458.764542 0 633.440863 87.658456 87.658456 202.188932 131.167389 316.720432 131.167389s229.062999-43.508933 316.720432-131.167389c174.676321-174.676321 174.676321-458.764542 0-633.440863C740.576929 107.403149 626.045429 63.894216 511.51393 63.894216zM511.51393 108.683305c52.466955 0 103.653755 10.237155 151.641699 29.432333 49.907667 20.475334 94.695732 49.907667 133.086088 88.937588 39.029922 38.390355 68.463278 83.179444 88.937588 133.086088 19.195178 47.987944 29.432333 99.174744 29.432333 151.641699s-10.237155 103.653755-29.432333 151.641699c-20.47431 49.907667-49.907667 94.695732-88.937588 133.086088-38.390355 39.029922-83.179444 68.463278-133.086088 88.937588-47.987944 19.195178-99.174744 29.432333-151.641699 29.432333-52.466955 0-103.653755-10.237155-151.641699-29.432333-49.907667-20.475334-94.695732-49.907667-133.086088-88.937588-39.029922-38.390355-68.463278-83.179444-88.937588-133.086088-19.195178-47.987944-29.432333-99.174744-29.432333-151.641699s10.237155-103.653755 29.432333-151.641699c20.475334-49.907667 49.907667-94.695732 88.937588-133.086088 38.390355-39.029922 83.179444-68.463278 133.086088-88.937588C407.860175 118.92046 459.046974 108.683305 511.51393 108.683305z' />
                    <path d='M511.51393 674.300456c-18.555611 0-34.55091 15.355733-34.55091 34.55091 0 18.555611 15.996322 33.911344 34.55091 33.911344 19.195178 0 34.55091-15.355733 34.55091-33.911344C546.065863 689.657212 530.709107 674.300456 511.51393 674.300456zM512.154519 280.799314c-42.2298 0-76.141144 10.877745-101.734032 33.911344-25.593911 22.394033-41.589211 55.026244-46.707788 97.895611l58.225099 7.0383c4.479011-31.991622 15.355733-55.665811 31.352055-70.381977 15.996322-15.355733 35.831067-22.394033 59.505255-22.394033 24.953322 0 46.068222 8.317433 63.343677 24.953322 16.635889 15.996322 24.953322 35.1915 24.953322 57.585533 0 11.517311-2.559289 23.034623-8.317433 33.271778-5.758144 10.237155-18.555611 23.674189-37.750789 40.949644-19.834744 17.275455-33.271778 30.072923-40.949644 39.029922-9.597589 12.156878-17.275455 24.313755-21.754466 36.470633-6.398734 15.996322-9.597589 35.1915-9.597589 56.945967l0.639566 17.275455 53.746088 0c0.639566-22.394033 1.919722-39.029922 4.479011-48.627511 3.198855-10.237155 7.0383-19.195178 12.796444-26.873044 5.758144-7.677866 17.275455-19.834744 35.831067-35.831067 26.873044-24.313755 45.428655-44.789089 55.026244-61.424978 8.958022-16.635889 14.0766-35.1915 14.0766-55.026244 0-34.55091-13.437034-63.984267-40.310078-88.298022C592.773651 292.956192 556.942585 280.799314 512.154519 280.799314z' />
                  </svg>
                </span>
                <div role="tooltip" part="tooltip" id="shipping-protection-details">
                  <span>${shippingProtectionTooltip}</span>
                </div>
              </span>`
          : ``
        }
          </shipping-protection>`
        : ``
      }

      <div class="sidecart__footer-wrapper">
        <div class="footer__subtotal">
          <p class="subtotal-label">Subtotal</p>
          <p class="subtotal-price"><span class="money">${this.CURRENCY_SYMBOL}${(
        cartData.items_subtotal_price / 100
      ).toFixed(2)}</span></p>
        </div>
        <div class="footer__disclaimer">
          <p>
          ${window.Shopify.locale === "es"
        ? 'Impuestos y <a href="/policies/shipping-policy">envío</a> calculados en el pago'
        : 'Taxes and <a href="/policies/shipping-policy">shipping</a> calculated at checkout'
      }
          </p>
        </div>
        <div class="custom-checkout-container">
          <span class="custom-checkout-btn" onclick="window.location.href='${window.Shopify.routes.root
      }checkout'">${window.Shopify.locale === "es" ? "CONTINÚE" : "CONTINUE"}
          </span>
          <div class="custom-payment-methods-wrapper" onclick="window.location.href='${window.Shopify.routes.root
      }checkout'">
            <img
              src="https://cdn.shopify.com/s/files/1/0038/6049/6433/files/bartesian-payment-methods.png?v=1730829442"
              alt="payment methods"
            >
          </div>
        </div>
      </div>
    `;

    return updatedFooterHTML;
  }

  renderEmptyCart() {
    const updatedEmptyHTML = `
      <div class="sidecart__empty-wrapper">
        <p class="empty-msg">Your cart is currently empty.</p>
      </div>
    `;
    return updatedEmptyHTML;
  }

  reRenderShipping(cartData) {
    const noShipping =
      cartData.items.filter((item) => item.product_id == "7249102143687").length > 0 ? true : false;
    if (this.shippingContainer.style.display != "none") {
      if (noShipping) {
        this.shippingContainer.style.display = "none";
        return;
      } else {
        this.shippingContainer.style.display = "block";
      }
    }

    let giftCardPrices = 0;
    let excludeShippingThresholdPrices = 0;

    const giftCards = cartData.items.filter((item) => item.handle === "gift-card");
    if (giftCards.length > 0) {
      giftCardPrices = giftCards
        .map((giftCard) => giftCard.final_line_price)
        .reduce((curr, acc) => curr + acc);
    }

    const getExcludeShippingThresholdProducts = JSON.parse(
      this.querySelector('[type="application/json"][shipping-threshold]').textContent
    );

    const excludeShippingThresholdProductsInCart = [];
    getExcludeShippingThresholdProducts.excludeShippingThresholdProducts.forEach((p) => {
      cartData.items.forEach((item) => {
        if (item.product_id == p.id) {
          excludeShippingThresholdProductsInCart.push(item);
        }
      });
    });
    if (excludeShippingThresholdProductsInCart.length > 0) {
      excludeShippingThresholdPrices = excludeShippingThresholdProductsInCart
        .map((excludeShippingThresholdProduct) => excludeShippingThresholdProduct.final_line_price)
        .reduce((curr, acc) => curr + acc);
    }

    let cartMsgUpdated = `
    ${cartData.original_total_price - giftCardPrices - excludeShippingThresholdPrices <
        this.FREESHIPPING
        ? `${window.cartStrings.youre
        }  <span class="shipping-threshold">${this.CURRENCY_SYMBOL}${(
          (this.FREESHIPPING -
            (cartData.original_total_price - giftCardPrices - excludeShippingThresholdPrices)) /
          100
        ).toFixed(2)}</span> ${window.cartStrings.fromFreeShipping
        }`
        : `${window.cartStrings.youQualifyForFreeShipping
        }`
      }
  `;

    let exclusiveFreeShippingEnabled = false;

    function checkCartForProducts(cartData) {
      let hasProduct1 = false;
      let hasProduct2 = false;

      for (let item of cartData.items) {
        if (item.product_id == 7779636314311 && item.quantity >= 1) {
          hasProduct1 = true;
        } else if (item.product_id == 7779651420359 && item.quantity >= 1) {
          hasProduct2 = true;
        }

        if (hasProduct1 && hasProduct2) {
          break;
        }
      }

      return hasProduct1 && hasProduct2;
    }

    let hasBoth = checkCartForProducts(cartData);

    if (
      cartData.items.find(
        (item) =>
          hasBoth ||
          (item.product_id == 7779636314311 && item.quantity >= 2) ||
          (item.product_id == 7779651420359 && item.quantity >= 2)
      )
    ) {
      cartMsgUpdated = "You qualify for free shipping!";
      exclusiveFreeShippingEnabled = true;
    }

    this.shippingMsg.innerHTML = cartMsgUpdated;
    const percentage = (
      ((cartData.original_total_price - giftCardPrices - excludeShippingThresholdPrices) /
        this.FREESHIPPING) *
      100
    ).toFixed(0);
    if (this.shippingMeter) {
      this.shippingMeter.style.width = percentage > 100 ? "100%" : `${percentage}%`;
    }

    if (this.shippingMeterContainer && this.shippingIndex) {
      if (exclusiveFreeShippingEnabled) {
        this.shippingMeterContainer.style.display = "none";
        this.shippingIndex.style.display = "none";
      } else {
        this.shippingMeterContainer.style.display = "block";
        this.shippingIndex.style.display = "flex";
      }
    }
  }

  reRenderBubble(itemCount) {
    const updatedBubbleHTML = `
      <span aria-hidden="true">${itemCount <= 9 ? itemCount : "9+"}</span>
      <span class="visually-hidden">${itemCount == 1 ? `${itemCount} item` : `${itemCount} items`
      }</span>
    `;
    return updatedBubbleHTML;
  }

  // dispatchCartUpdateEvent removed - CartStateManager handles this now
}

customElements.define("side-cart", SideCart);

class SideCartItem extends HTMLElement {
  constructor() {
    super();

    this.loadingScreen = this.querySelector(".action-loading");
    this.variantId = this.dataset.variantId;
    this.lineIndex = this.dataset.lineIndex;
    this.key = this.dataset.key;
    this.sideCart = this.closest("side-cart");
    this.qtyInput = this.querySelector("#itemQty");
    this.qtyButtons = this.querySelectorAll(".sidecart__buttons .qty-controller");
    this.country = this.dataset.country;

    // Debounced quantity update (500ms like cart page)
    this.debouncedUpdateQuantity = debounce((variantId, key, quantity) => {
      this.executeQuantityUpdate(variantId, key, quantity);
    }, 500);

    this.init();

    this.BARTESIAN_MACHINE_DEFAULT_VARIANT_ID = 15685587206193;
    this.BARTESIAN_DUET_MACHINE_DEFAULT_VARIANT_ID = 42837907636423;
    this.BARTESIAN_PROFESSIONAL_MACHINE_DEFAULT_VARIANT_ID = 42799244083399;
    this.STOCK_THE_BAR_GIFT_DEFAULT_VARIANT_ID = 43298440380615;
  }

  init() {
    if (this.qtyButtons && this.qtyButtons.length > 0) {
      this.qtyButtons.forEach((qtybtn) => {
        qtybtn.addEventListener("click", this.qtyBtnClick.bind(this, qtybtn));
      });
    }
  }

  async removeBundleProducts(bundleId) {
    var lineQuantities = [];
    localStorage.setItem("existSubscriptionInfoSideCart", false);
    $(".subscription-btn[has-subscription=true]").attr("has-subscription", false);
    // Create an array for line updates - each number in the array sets the quantity for the corresponding
    // line item in the cart (e.g. array[1] matches the second line item)
    this.sideCart.querySelectorAll("side-cart-item").forEach((item, index) => {
      item.dataset.bundleId ? lineQuantities.push(0) : lineQuantities.push(item.qtyInput.value);
    });

    this.loadingScreen.classList.add("loading");

    const sideCart = this.sideCart;
    const cartData = await sideCart.multiupdateCart(lineQuantities);

    this.loadingScreen.classList.remove("loading");
  }

  qtyBtnClick(qtybtn, event) {
    const variantId = this.variantId;
    const key = this.key;
    const updateType = qtybtn.dataset.updateType;
    const currentQty = this.qtyInput ? parseInt(this.qtyInput.value) : 1;
    const bundleId = this.dataset.bundleId;

    if (bundleId) {
      this.removeBundleProducts(bundleId);
      return;
    }

    if (!currentQty || isNaN(currentQty)) {
      return;
    }

    let newQty;
    switch (updateType) {
      case "remove":
        newQty = 0;
        break;
      case "minus":
        newQty = Math.max(0, currentQty - 1);
        break;
      case "plus":
        newQty = currentQty + 1;
        break;
      default:
        return;
    }

    // Optimistic UI update - update input immediately
    if (this.qtyInput && newQty > 0) {
      this.qtyInput.value = newQty;
    }

    // Debounced API call - waits 500ms after last click
    this.debouncedUpdateQuantity(variantId, key, newQty);
  }

  /**
   * Execute the actual quantity update (called by debounced function)
   */
  async executeQuantityUpdate(variantId, key, variantQty) {
    const BartesianPricingUI = document.querySelector(
      `bartesian-pricing-ui[variant-id="${variantId}"]`
    );

    if (BartesianPricingUI && BartesianPricingUI.getAttribute("current-template") !== "product") {
      setTimeout(() => {
        BartesianPricingUI.fetchInitialQuantity(true);
      }, 1000);
    }

    // Show loading screen
    this.loadingScreen.classList.add("loading");

    try {
      // Use CartStateManager - it will handle serialization and state updates.
      // Pass the line item key (variant_id + properties hash) instead of a
      // line index, so concurrent removals don't shift the target row.
      await window.cartStateManager.updateQuantity(key, variantQty);
      // State change will trigger side cart re-render automatically
    } catch (error) {
      console.error('Error updating quantity in side cart:', error);
      this.sideCart.showErrorPopup(error.message || 'Failed to update quantity');

      // Revert optimistic UI update on error
      if (this.qtyInput) {
        const currentState = window.cartStateManager.getState();
        const item = currentState.items.find((it) => it.key === key);
        if (item) {
          this.qtyInput.value = item.quantity;
        }
      }
    } finally {
      this.loadingScreen.classList.remove("loading");
    }
  }
}

customElements.define("side-cart-item", SideCartItem);

class SideCartItemUpsell extends HTMLElement {
  constructor() {
    super();

    this.loadingScreen = this.querySelector(".action-loading");
    this.variantId = this.dataset.variantId;
    this.sideCart = this.closest("side-cart");
    // this.upsellModalOpen = this.querySelector(".sidecart__buttons .upsell-modal-open");
    this.upsellACT = this.querySelector(".sidecart__buttons .upsell-act");
    this.variantSelectWrapper = this.querySelector(".sidecart__variants");
    this.variantSelect = this.variantSelectWrapper.querySelector(".variants__select");
    this.init();
  }

  init() {
    // if(this.upsellModalOpen) {
    //   this.upsellModalOpen.addEventListener("click", this.variantsModalShow.bind(this));
    // }
    if (this.upsellACT) {
      this.upsellACT.addEventListener("click", this.addToCart.bind(this));
    }
    if (this.variantSelect) {
      this.variantSelect.addEventListener("change", this.updatePrice.bind(this));
    }
  }

  // variantsModalShow(){
  //   this.variantSelectWrapper.classList.toggle('show');
  //   if(this.variantSelectWrapper.classList.contains('show')){
  //     this.upsellModalOpen.classList.add('hide');
  //     this.upsellACT.classList.add('show');
  //   }
  // }

  updatePrice() {
    const selectedOption = [].filter.call(
      this.variantSelect.options,
      (option) => option.selected
    )[0];
    if (selectedOption) {
      const price = this.querySelector(".item-price");
      price.innerHTML = `<strong>$${selectedOption.dataset.price}</strong>`;
    }
  }
  addToCart() {
    this.loadingScreen.classList.add("loading");
    if (this.variantSelect.value !== "") {
      let _numCapsulesPerBox;

      const productType = this.variantSelect
        .querySelector("option")
        .getAttribute("data-product-type");

      if (
        this.variantSelect.value === 7697851908295 ||
        this.variantSelect.value === 7701507276999
      ) {
        // Classic Collection Favorites Variety Pack
        // https://admin.shopify.com/store/bartesianshop/products/7697851908295 (USA & Canada)
        // https://admin.shopify.com/store/bartesianshop/products/7701507276999 (UK)
        _numCapsulesPerBox = 6;
      } else if (this.variantSelect.value === 8035822534855) {
        // 2024 Advent Calendar
        _numCapsulesPerBox = 12;
      } else if (this.variantSelect.value === 8773255692487) {
        // 2026 Advent Calendar Test
        _numCapsulesPerBox = 12;
      } else if (this.variantSelect.value === 7519374901447) {
        // 2024 Advent Calendar Test
        _numCapsulesPerBox = 12;
      } else {
        _numCapsulesPerBox = 8;
      }

      const properties =
        productType === "cocktails"
          ? {
            _showModifiedPricing: true,
            _modifiedPricing: this.variantSelect.getAttribute("data-price"),
            _numCapsulesPerBox,
          }
          : {};

      this?.sideCart?.addToCart(this.variantSelect.value, 1, undefined, properties)
        .then(() => {
          this.loadingScreen.classList.remove("loading");
        });

      const headerIcons = document.querySelector(".header__icons");
      const shopNowButton = headerIcons?.querySelector(".btn--shop-all");
      if (shopNowButton && !headerIcons.classList.contains("has-cart-item")) {
        headerIcons.classList.add("has-cart-item");
      }
    } else {
      this.loadingScreen.classList.remove("loading");
      this.upsellACT.disabled = true;
    }
  }
}

customElements.define("side-cart-item-upsell", SideCartItemUpsell);

class UpsellButton extends HTMLElement {
  constructor() {
    super();

    this.atcBtn = this.querySelector(".upsell-button");
    this.sideCart = this.closest("side-cart");
    this.init();
  }

  init() {
    this.atcBtn.addEventListener("click", this.onATCClick.bind(this));
  }
  onATCClick() {
    const varId = this.atcBtn.dataset.variantId;
    this.sideCart.addToCart(varId, 1);
  }
}

customElements.define("upsell-button", UpsellButton);

class Subscription extends HTMLElement {
  constructor() {
    super();
    this.sideCart = document.querySelector("side-cart");
    this.bundleId = this.generateBundleId();
    this.cocktailSection = this.querySelector(".bundle-left");
    this.init();
  }

  async init() {
    localStorage.setItem("existSubscriptionInfoSideCart", false);
    let existSubscriptionInfoSideCart = localStorage.getItem("existSubscriptionInfoSideCart");

    const data = await this.sideCart.getCart();
    this.sideCart.classList.remove("cart--open");
    document.querySelector("body").classList.remove("overflow-hidden");

    const tempCartItems = [...data.items];
    if (tempCartItems.filter((item) => Object.keys(item.properties).length > 0).length) {
      localStorage.setItem("existSubscriptionInfoSideCart", true);
      this.querySelector(".subscription-btn").setAttribute("has-subscription", "true");
    }

    this.querySelector(".subscription-btn").addEventListener(
      "click",
      this.scrollToCocktails.bind(this),
      true
    );

    this.querySelector(".subscription-btn").addEventListener(
      "click",
      async (event) => {
        // manually disabled class
        if (event.target.classList.contains("disabled")) return;
        else {
          if (localStorage.getItem("existSubscriptionInfoSideCart") == "false") {
            var items = [];
            const planMonth = this.querySelector(".subscription-plan select").value;
            const subscriptionProduct = this.querySelector(".bundle-pack.active");
            const variant_id = subscriptionProduct.dataset.variant;

            const planSelector = this.querySelector("#plan-select");
            const selectedOption = planSelector.options[planSelector.selectedIndex];
            const p_selling_id = selectedOption.getAttribute("data-id");

            this.querySelectorAll(".bundle-product .qty-selector.active").forEach((item) => {
              const subproducts = item.closest(".bundle-product").getAttribute("data-variantid");
              const quantity = item.querySelector(".qty-value").textContent;
              const selling_id = item
                .closest(".bundle-product")
                .getAttribute(`data-sellingid-${planSelector.value}`);

              items.push({
                id: subproducts,
                quantity: quantity,
                selling_plan: selling_id,
                property: { bundle_id: this.bundleId },
              });
            });

            items.push({
              id: variant_id,
              selling_plan: p_selling_id,
              property: { bundle_id: this.bundleId },
            });

            const tempNewItems = items.map((item) => item.id);
            const overlappedItems = tempNewItems.filter((item) => tempNewItems.includes(item));

            if (overlappedItems.length >= 1) {
              localStorage.setItem("existSubscriptionInfoSideCart", true);
            }

            $(".subscription-btn").attr("has-subscription", true);
            document
              .querySelector(".subscription-btn[has-subscription=true]")
              ?.removeEventListener("click", showMyPopUp);
            document
              .querySelectorAll(
                ".builder-error-modal-small-close-button, .builder-error-modal-close-button"
              )
              ?.forEach((elem) => elem.removeEventListener("click", hideMyPopUp));

            await this.sideCart.addSubscriptionsToCart(items);
          } else {
            document
              .querySelector(".subscription-btn[has-subscription=true]")
              ?.addEventListener("click", showMyPopUp);
            document
              .querySelectorAll(
                ".builder-error-modal-small-close-button, .builder-error-modal-close-button"
              )
              ?.forEach((elem) => elem.addEventListener("click", hideMyPopUp));
          }
        }
      },
      true
    );

    function showMyPopUp() {
      $(".popup, .popup-content").addClass("custom-popup-active");
      $(".subscription-btn").attr("disabled", true);
    }

    function hideMyPopUp() {
      $(".popup, .popup-content").removeClass("custom-popup-active");
      $(".subscription-btn[has-subscription=true]").removeAttr("disabled");
    }
  }

  generateBundleId() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  scrollToCocktails(event) {
    const btnElm = event.target;
    const btnContainer = btnElm.closest(".bundle-payment");
    const windowWidth = window.innerWidth;
    if (windowWidth > 768 || !btnElm.classList.contains("disabled")) return;
    else {
      const cocktailsPosition = this.cocktailSection.offsetTop;
      const btnPosition = btnElm.offsetTop;

      if (cocktailsPosition > btnPosition && !btnContainer.classList.contains("stickyactive")) {
        window.scrollTo({ top: cocktailsPosition - 40, behavior: "smooth" });
      }
    }
  }
}

customElements.define("bundle-subscription", Subscription);

class AddToCartPLP extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  connectedCallback() {
    this.render();
    this.shadowRoot
      .querySelector("button")
      .addEventListener("click", (event) => this.addToCart(event));
  }

  disconnectedCallback() {
    this.shadowRoot.querySelector("button").removeEventListener("click", this.addToCart);
  }

  async addToCart() {
    try {
      const variantId = this.getAttribute("data-variantid");
      const sideCart = document.querySelector("side-cart");

      if (sideCart && sideCart.addToCart) {
        // Use side-cart's addToCart method which uses CartStateManager
        await sideCart.addToCart(variantId, 1);
      } else {
        console.error("Side cart not found or addToCart method not available");
      }
    } catch (error) {
      console.error("Error adding to cart:", error);
    }
  }

  render() {
    this.shadowRoot.innerHTML = `
      <style>
        .add-to-cart-btn {
          display: flex;
          color: white;
          background: #008fbb;
          width: 50px;
          height: 50px;
          justify-content: center;
          align-items: center;
          border: 1px solid #008fbb;
          font-size: 1.5rem;
          border-radius: 50%;
          position: absolute;
          margin: 0;
          padding: 0;
          right: 0;
        }

        .add-to-cart-btn:hover {
          cursor: pointer;
        }

        @media screen and (max-width: 768px) {
          .add-to-cart-btn {
            width: 35px;
            height: 35px;
          }
        }
      </style>
      <button class="add-to-cart-btn" type="button">
        <div aria-hidden="true" class="add-to-cart-btnSmall__quantity">+</div>
      </button>
    `;
  }
}

customElements.define("add-to-cart-plp", AddToCartPLP);
